import { FC } from "react";
import { Box, createStyles, makeStyles, Typography } from "@material-ui/core";
import {
  MoneyOff as MoneyOffIcon,
  ShowChart as ShowChartIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from "@material-ui/icons";

import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    hiddenRowContainer: {
      textAlign: "center",
      padding: theme.spacing(1),
    },
    hiddenRowTitle: {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: "1.8rem",
      margin: theme.spacing(2, 0),
    },
    hiddenRowText: {
      fontSize: "1rem",
      margin: theme.spacing(1, 0),
    },
    visibilityOffIcon: {
      fontSize: "10rem",
      color: theme.custom.palette.blue.main,
      [theme.breakpoints.down("sm")]: {
        fontSize: "7.5rem",
      },
    },
    iconMargin: {
      marginBottom: "3px",
    },
    visibilityIcon: {
      color: theme.custom.palette.yellow.main,
      marginRight: theme.spacing(1),
    },
    showChartIcon: {
      color: theme.custom.palette.green.main,
      marginRight: theme.spacing(1),
    },
    moneyOffIcon: {
      color: theme.custom.palette.red.main,
      marginRight: theme.spacing(1),
    },
  }),
);

const HiddenContent: FC = ({}) => {
  const classes = useStyles();

  return (
    <Box className={classes.hiddenRowContainer}>
      <VisibilityOffIcon className={classes.visibilityOffIcon} />
      <Typography className={classes.hiddenRowTitle}>
        Your Listing is Hidden
      </Typography>
      <Box className={classes.hiddenRowText}>
        <VisibilityIcon
          className={`${classes.visibilityIcon} ${classes.iconMargin}`}
        />
        <Typography component="span">
          Only you are able to see this page
        </Typography>
      </Box>
      <Box className={classes.hiddenRowText}>
        <ShowChartIcon
          className={`${classes.showChartIcon} ${classes.iconMargin}`}
        />
        <Typography component="span">
          Earnings analytics will be updated with every new payment
        </Typography>
      </Box>
      <Box className={classes.hiddenRowText}>
        <MoneyOffIcon
          className={`${classes.moneyOffIcon} ${classes.iconMargin}`}
        />
        <Typography component="span">
          You will not be able to receive offers while this is hidden
        </Typography>
      </Box>
    </Box>
  );
};

export default HiddenContent;
